import {BaseCartController} from '../../domain/controllers/BaseCartController';
import {getFreeTextKeys} from './settingsParams';
import {ICartStyleSettings} from '../../types/app.types';
import {SIDE_CART_ORIGIN} from '../../common/constants';

export class SideCartController extends BaseCartController {
  protected getOrigin() {
    return SIDE_CART_ORIGIN;
  }
  protected getDefaultSettings() {
    return {} as ICartStyleSettings;
  }

  public exports() {
    return {};
  }

  public getFreeTexts(): string[] {
    return getFreeTextKeys();
  }
}
